import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType, } from "react-router-dom";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";
import React from "react";
import { installPediaTokenInterceptors } from "./pages/tatvaPedia/pediaToken";
import { getSentryRelease, WEB_BUILD } from "./utils/buildInfo";

// Release check from the console / Safari Web Inspector / native injectJavaScript
window.__PWA_BUILD__ = { version: WEB_BUILD.version };

Sentry.init({
  dsn: "https://91d7e547ef0e8436cd9a0dd4a2a04c87@o4509755819294720.ingest.us.sentry.io/4510737293115392",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: ["prod", "zy-preprod", "zy-prod"].includes(
    process.env.REACT_APP_ENV || ""
  )
    ? 0.1
    : 1.0,
  tracePropagationTargets: [],
  sendDefaultPii: true,
  environment: process.env.REACT_APP_ENV,
  release: getSentryRelease(),
  beforeSend(event) {
    // Filter out development errors or specific error types
    if (event.environment === "dev") return null;
    return event;
  },
});

installPediaTokenInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter basename={"/"}>
    <App />
  </BrowserRouter>
);

reportWebVitals();

registerServiceWorker();
